import { Font, Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from "react";
import { extractResumeDataDocumentSection } from "../../../hooks/useResumeDocumentSection";
import { extractResumeProperties } from "../../../hooks/useResumeProperties";
import { getInitials } from "../../../utils/getInitials";
import { formatPrenom } from "../../../utils/formatPrenom";

Font.registerHyphenationCallback( ( word ) => {
    if ( word.length <= 20 ) {
        return [ word ];
    }
    return word.split( '' );
} );

export default function CommonPdfIntroductionSection( { resumeData, translations } ) {
    const { introduction, user } = extractResumeDataDocumentSection( resumeData );
    const { isAlcyone, isAnonymous, jobTitle } = extractResumeProperties( resumeData );
    const hasIntroduction = typeof introduction === 'string'
        ? introduction.trim() !== ''
        : Boolean( introduction );

    const styles = StyleSheet.create( {
        section: {
            flexDirection: 'row',
            marginBottom: '10px',
            fontSize: '10pt',
            alignItems: 'center',
        },
        imagePage: {
            height: '50px',
            marginTop: '-8px',
        },
        nameBlock: {
            flexDirection: 'column',
            marginLeft: '12px',
            marginTop: '0px',
        },
        user: {
            fontSize: '16pt',
            fontWeight: 'bold',
            marginTop: 0,
        },
        poste: {
            fontSize: '12pt',
            fontWeight: 'bold',
            marginTop: '4px',
            marginLeft: '28px',
            color: '#808080',
            width: '50%',
        },
        calculExp: {
            textAlign: 'right',
            color: '#808080',
            marginTop: '5px',
            marginBottom: '10px',
            fontSize: '8pt',
            marginRight: '5px',
        },
    } );

    return (
        <>
            <View style={ { ...styles.section, marginTop: '-30px' } }>
                { isAlcyone && (
                    <Image
                        style={ styles.imagePage }
                        src="/spinner-alcyone.png"/>
                ) }
                <View style={ styles.nameBlock }>
                    <Text style={ styles.user }>
                        { isAnonymous
                            ? getInitials( user.firstName ) + ' ' + getInitials( user.lastName, true )
                            : formatPrenom( user.firstName ) + ' ' + user.lastName?.toUpperCase()
                        }
                    </Text>
                    { jobTitle ? <Text style={ styles.poste }>{ jobTitle }</Text> : null }
                </View>
            </View>
            { hasIntroduction && (
                <View style={ [ styles.section, { marginBottom: 4, flexDirection: 'column', alignItems: 'stretch' } ] }>
                    <Text style={ { textAlign: 'justify', fontSize: 8, width: '100%' } }>{ introduction }</Text>
                </View> ) }
        </>
    );
}
